import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const getCategories = (
	params = {
		per_page: 10,
		page: 1,
		'filter[term]': '',
	},
) => Http.get(`/reports/categories/fetch${serialize(params)}`)

//SAVE A NEW CATEGORY
export const saveCategory = (
	params = {
		name: null,
	},
) => Http.post(`/reports/categories/store`, params)

//UPDATE CATEGORY
export const updateCategory = (
	params = {
		name: null,
		categoryId: null,
	},
) => Http.put(`/reports/categories/${params.categoryId}/update`, params)

// DELETE CATEGORY
export const deleteCategory = (
	params = {
		categoryId: null,
	},
) => Http.delete(`/reports/categories/${params.categoryId}/destroy`, params)
